import annotations from './modules/annotations';
import auth from './modules/auth';
import counterpoint from './modules/counterpoint';
import document from './modules/document';
import general from './modules/general';
import geometries from './modules/geometries';
import hover from './modules/hover';
import organization from './modules/organization';
import outline from './modules/outline';
import team from './modules/team';
import user from './modules/user';
import share from './modules/share';
import status from './modules/status';
import logger from './modules/logger';

export default {
  ...annotations.state,
  ...auth.state,
  ...counterpoint.state,
  ...document.state,
  ...general.state,
  ...geometries.state,
  ...hover.state,
  ...organization.state,
  ...outline.state,
  ...team.state,
  ...user.state,
  ...share.state,
  ...status.state,
  ...logger.state,
};
